// extracted by mini-css-extract-plugin
module.exports = {"root":"Skeleton_root__3bOHR"};